export const API_PATH = 'payments';
export const API_BASE = process.env.CONTRACTORS_API;
